import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import YearFilter from '../selectComponents/YearFilter';

const variableChoices = [
  {value: 'temp',   label: 'Temperature'},
  {value: 'wchill', label: 'Wind Chill',},
  {value: 'htindx', label: 'Heat Index',},
  {value: 'dwpt',   label: 'Dewpoint',},
  {value: 'wetb',   label: 'Wet Bulb Temperature',},
  {value: 'pcpn',   label: 'Precipitation',},
]

const smryChoices = [
  {value: 'hrofmax', label: 'Hour of highest value'},
  {value: 'hrofmin', label: 'Hour of lowest value'},
]

export default function OcchrlyOptions(props) {
  const { userParams, setUserParams, selectOptions, handleChange } = props;

  return (
    <>
      <Stack direction="column" alignItems="baseline" spacing={1} sx={{ mt: 1 }}>
        <YearFilter 
          userParams={userParams}
          setUserParams={setUserParams}
          selectOptions={selectOptions}
          handleChange={handleChange}
        />
        <Box>
          <TextField
            select
            name="variable"
            label="Variable"
            value={userParams.variable}
            onChange={handleChange}
            sx={{ "& .MuiSelect-icon": { right: '7px' } }}
          >
            {selectOptions(variableChoices)}
          </TextField>
          <TextField
            select
            name="smry"
            id="smry"
            label="Summary type"
            value={userParams.smry}
            onChange={handleChange}
            sx={{ ml: 1, "& .MuiSelect-icon": { right: '7px' } }}
          >
            {selectOptions(smryChoices)}
          </TextField>
        </Box>
      </Stack>
    </>
  )
}